































































































import Vue from "vue";

import { mapActions, mapState } from "vuex";
import { SET_DRAWER } from "@/store/modules/ApplicationModule/mutations";
import { GET_CURRENT_USER } from "@/store/modules/AuthenticationModule/actions";
import * as R from "@/router/routes";
import { RootState } from "@/store";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { UpdateCurrentUserCommand } from "@/model/communication/auth/UpdateCurrentUserCommand";
import { ClientUser } from "@/model/data/authentication/ClientUser";

export default Vue.extend({
    props: {
        loomisStyle: Boolean,
    },
    data() {
        return {
            expandOnHover: false,
            R,
            userConfigLoading: false,
        };
    },
    computed: {
        ...mapState({
            currentUser: (state: RootState) => state.authMod.currentUser,
            dashboardList: (state: RootState) => state.dashboard.dashboards,
        }),
        userConfig() {
            return this.currentUser.userConfig;
        },
        menuRoutes() {
            return this.$store.getters.availableMenu;
            // return this.$store.state.application.menu;
        },
        drawer: {
            get() {
                return this.$store.state.application.drawer;
            },
            set(value) {
                this.$store.commit(SET_DRAWER, value);
            },
        },
        navDrawerStyle() {
            return this.loomisStyle && this.$vuetify.breakpoint.lgAndUp ? "margin-top: 149px;max-height: calc(100% - 149px);" : "";
        },
    },
    methods: {
        ...mapActions([GET_CURRENT_USER]),
        async onLockMenuToggle() {
            this.userConfigLoading = true;

            var reqData = (this.currentUser as ClientUser).createUpdateCurrentUserReqData();
            reqData.userConfig.lockedMenu = !reqData.userConfig.lockedMenu;

            var res = await new UpdateCurrentUserCommand(reqData).execute();
            if (res.responseStatus == ApiResponseStatusEnum.Success) {
                await this[GET_CURRENT_USER]();
            }

            this.userConfigLoading = false;
        },
    },
});
